import Vue from 'vue'

//element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, {size: 'small'});

// 右键菜单弹窗
import EVueContextmenu from 'e-vue-contextmenu'
Vue.use(EVueContextmenu)

import XcBaseTable from '@/components/xc-common/xc-base_table.vue'
import XcBaseTableSearch from '@/components/xc-common/xc-base_table_search.vue'
import XcBaseFormDialog from '@/components/xc-common/xc-base_form_dialog.vue'
Vue.component('XcBaseTable', XcBaseTable)
Vue.component('XcBaseTableSearch', XcBaseTableSearch)
Vue.component('XcBaseFormDialog', XcBaseFormDialog)

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
